import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function ccr8(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@ccr8/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccr8/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccr8/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@ccr8/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@ccr8/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@ccr8/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}